function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { forwardRef, useState } from 'react';
import { NextButtonIcon, PrevButtonIcon } from '@aelf-design/icons';
import { useResponsive, useTheme } from 'antd-style';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import useStyles from "./styles";
import 'swiper/swiper-bundle.css';
var Carousel = /*#__PURE__*/forwardRef(function (props, ref) {
  var _token$customCarousel, _token$customCarousel2, _token$customCarousel3, _token$customCarousel4, _token$customCarousel5, _token$customCarousel6;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    thumbsSwiper = _useState2[0],
    setThumbsSwiper = _useState2[1];
  var data = props.data,
    onSlideClick = props.onSlideClick,
    className = props.className,
    _props$thumbsSlidesPe = props.thumbsSlidesPerView,
    thumbsSlidesPerView = _props$thumbsSlidesPe === void 0 ? 5 : _props$thumbsSlidesPe,
    thumbsSwiperWidth = props.thumbsSwiperWidth,
    galleryObjectFit = props.galleryObjectFit;
  var _useStyles = useStyles({
      thumbsSwiperWidth: thumbsSwiperWidth || 72 * thumbsSlidesPerView + (thumbsSlidesPerView - 1) * 16,
      galleryObjectFit: galleryObjectFit || 'cover'
    }),
    st = _useStyles.styles,
    cx = _useStyles.cx,
    prefixCls = _useStyles.prefixCls;
  var responsive = useResponsive();
  var token = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: cx(st.Carousel, prefixCls + 'carousel', className)
  }, /*#__PURE__*/React.createElement(Swiper, {
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next'
    },
    slidesPerGroupSkip: 1,
    spaceBetween: 16,
    slidesPerView: 'auto',
    centeredSlides: true,
    autoHeight: true,
    thumbs: {
      swiper: thumbsSwiper
    },
    modules: [FreeMode, Navigation, Thumbs],
    className: "swiper-gallery",
    ref: ref
  }, data.map(function (item, index) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      className: "gallery-slide",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "slide-container"
    }, /*#__PURE__*/React.createElement("img", {
      src: item.url,
      onClick: function onClick(e) {
        e.stopPropagation();
        onSlideClick === null || onSlideClick === void 0 || onSlideClick(item);
      }
    })));
  }), /*#__PURE__*/React.createElement("div", {
    className: "swiper-button-next"
  }, /*#__PURE__*/React.createElement(NextButtonIcon, {
    className: "navigation-button",
    color: (_token$customCarousel = token.customCarousel) === null || _token$customCarousel === void 0 ? void 0 : _token$customCarousel.colorNavigation,
    hoverColor: (_token$customCarousel2 = token.customCarousel) === null || _token$customCarousel2 === void 0 ? void 0 : _token$customCarousel2.colorNavigationHover,
    activeColor: (_token$customCarousel3 = token.customCarousel) === null || _token$customCarousel3 === void 0 ? void 0 : _token$customCarousel3.colorNavigationActive
  })), /*#__PURE__*/React.createElement("div", {
    className: "swiper-button-prev"
  }, /*#__PURE__*/React.createElement(PrevButtonIcon, {
    className: "navigation-button",
    color: (_token$customCarousel4 = token.customCarousel) === null || _token$customCarousel4 === void 0 ? void 0 : _token$customCarousel4.colorNavigation,
    hoverColor: (_token$customCarousel5 = token.customCarousel) === null || _token$customCarousel5 === void 0 ? void 0 : _token$customCarousel5.colorNavigationHover,
    activeColor: (_token$customCarousel6 = token.customCarousel) === null || _token$customCarousel6 === void 0 ? void 0 : _token$customCarousel6.colorNavigationActive
  }))), /*#__PURE__*/React.createElement(Swiper, {
    onSwiper: function onSwiper(swiper) {
      setThumbsSwiper(swiper);
    },
    autoHeight: true,
    spaceBetween: responsive.md ? 16 : 12,
    slidesPerView: thumbsSlidesPerView,
    freeMode: true,
    watchSlidesProgress: true,
    modules: [FreeMode, Navigation, Thumbs],
    className: "thumbs-swiper"
  }, data.map(function (item, index) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      className: cx(responsive.lg ? 'thumbs-slide' : 'mobile-thumbs-slide'),
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "slide-container"
    }, /*#__PURE__*/React.createElement("img", {
      src: item.url
    }), /*#__PURE__*/React.createElement("div", {
      className: "slide-mask"
    })));
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Carousel.displayName = 'Carousel';
}
export default Carousel;